import axios from 'axios'
import 'vue3-toastify/dist/index.css'
import { toast } from 'vue3-toastify'
/* Restore this after TSID login review
Add a flag in service call to avoid toast notification
Check bomImageUploader
import Vue from 'vue'
import VueNoty from 'vuejs-noty'

import 'vuejs-noty/dist/vuejs-noty.css'

Vue.use(VueNoty)*/

const CSRF_COOKIE_NAME = 'csrftoken'
const CSRF_HEADER_NAME = 'X-CSRFToken'

window.getCookie = function (cname) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

window.createApiService = (isShowError = false, isUnwrap = true) => {
  const apiService = axios.create({
    baseURL:
      (window.websiteConfig && window.websiteConfig.apiUrl) ||
      'http://localhost:3253/api/',
    timeout: (window.websiteConfig && window.websiteConfig.timeout) || 30000,
    xsrfCookieName: CSRF_COOKIE_NAME,
    xsrfHeaderName: CSRF_HEADER_NAME,
  })

  // Request Interceptor
  apiService.interceptors.request.use(
    config => {
      const tk = localStorage.getItem('WebApiToken')
      if (!window.websiteConfig || (tk && !window.websiteConfig.skipAuth)) {
        // config.headers.Authorization = `Bearer ${tk}`
        config.headers.Token = tk
      }

      const bomTkn = localStorage.getItem('bomToken')
      if (bomTkn) {
        config.headers.bomToken = bomTkn
      }

      return config
    },
    error => {
      // Do something with request error
      console.error(error) // for debug
      Promise.reject(error)
    }
  )

  if (isShowError) {
    apiService.interceptors.response.use(
      response => {
        if (!isUnwrap) {
          return response
        } else if (response.status >= 400) {
          return Promise.reject('error')
        } else return response.data
      },
      error => {
        if (isShowError) {
          toast('Si è verificato un errore', {
            type: 'error',
            icon: false,
          })
        }
        console.error(error) // for debug
        return Promise.reject(error)
      }
    )
  }

  return apiService
}

const apiService = window.createApiService()

// Response Interceptor
apiService.interceptors.response.use(
  response => {
    if (response.status >= 400) {
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    //Vue.noty.error('Si è verificato un errore')
    console.error(error)
    return Promise.reject(error)
  }
)

export default apiService
